
const display_date = (dt) => {
    const options = {dateStyle: 'long'}
    const displayDate = new Date(dt  * 1000);
    return displayDate.toLocaleString("en-GB", options);
}

const display_date_short = (dt) => {
    const options = {year: '2-digit', month: '2-digit', day: '2-digit'}
    const displayDate = new Date(dt * 1000);
    return displayDate.toLocaleString("en-GB", options);
}

const display_date_time = (dt) => {
    const options = {dateStyle: 'short', timeStyle: 'short'}
    const displayDate = new Date(dt);
    return displayDate.toLocaleString("en-GB", options);
}

const short_display_date = (dt) => {
    const options = {dateStyle: 'short'}
    const displayDate = new Date(dt  * 1000);
    return displayDate.toLocaleString("en-GB", options);
}

const date_display_diff = (diff) => {
    if (!diff) return "";
    let result = "";
    const hours = Math.floor(diff/(60*60*1000));
    if (hours > 0){
        result += hours + "H";
    }
    diff = diff - (hours * 60*60*1000);
    const minutes = Math.floor(diff/(60*1000));
    if (minutes > 0)
        result += " " + minutes + "M";
    return result;
}

const date_to_timestamp = (date) => {
    if (!date) return null;

    return new Date(date).getTime()/1000
}

export default {
    display_date,
    display_date_short,
    display_date_time,
    short_display_date,
    date_display_diff,
    date_to_timestamp
}